import { render, staticRenderFns } from "./LeftTop.vue?vue&type=template&id=06ce043f&scoped=true"
import script from "./LeftTop.vue?vue&type=script&lang=js"
export * from "./LeftTop.vue?vue&type=script&lang=js"
import style0 from "./LeftTop.vue?vue&type=style&index=0&id=06ce043f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ce043f",
  null
  
)

export default component.exports